/**
 * Stable React keys for lists whose items carry no id (AI-generated bullet
 * points, split paragraphs, words). Keys derive from item content so React can
 * preserve element identity across re-renders; exact duplicates get a numeric
 * suffix so keys stay unique.
 *
 *   keyedList(['a', 'b', 'a']) -> [{ key: 'a', item: 'a' }, { key: 'b', item: 'b' }, { key: 'a#1', item: 'a' }]
 *   keyedList(shots, (s) => s.title)
 */
export const keyedList = (items, pick = (x) => x) => {
  const seen = new Map();
  return (items || []).map((item) => {
    const base = String(pick(item) ?? '').slice(0, 80);
    const n = seen.get(base) || 0;
    seen.set(base, n + 1);
    return { key: n ? `${base}#${n}` : base, item };
  });
};
